import {
  GET_PROFILE,
  GET_PROFILE_FAIL,
  GET_PROFILE_SUCCESS,
  REMOVE_USER_INFO,
  RESET_UPLOAD_AVATAR,
  UPDATE_PROFILE,
  UPDATE_PROFILE_FAIL,
  UPDATE_PROFILE_SUCCESS,
  UPLOAD_AVATAR,
  UPLOAD_AVATAR_FAIL,
  UPLOAD_AVATAR_SUCCESS,
} from "./actionTypes";

const initialState = {
  userInfo: null,
  avatar_id: null,
  avatarImg: null,
  avatar_id_upload: null,
  loading: false,
  error: null,
};

const profile = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROFILE:
      return {
        ...state,
        loading: true,
      };
    case GET_PROFILE_SUCCESS:
      return {
        ...state,
        type: action.type,
        loading: false,
        userInfo: action.userInfo,
        avatar_id: action.avatar_id,
        avatarImg: action.avatarImg,
      };
    case GET_PROFILE_FAIL:
      return {
        ...state,
        loading: false,
        type: action.type,
        error: action.error,
      };
    case REMOVE_USER_INFO:
      return {
        ...state,
        userInfo: null,
        avatar_id: null,
        avatarImg: null,
        error: null,
      };
    //
    case UPLOAD_AVATAR:
      return {
        ...state,
        loading: true,
      };
    case UPLOAD_AVATAR_SUCCESS:
      return {
        ...state,
        type: action.type,
        loading: false,
        avatar_id_upload: action.avatar_id_upload,
      };
    case UPLOAD_AVATAR_FAIL:
      return {
        ...state,
        type: action.type,
        loading: false,
        error: action.error,
      };
    case RESET_UPLOAD_AVATAR:
      return {
        ...state,
        loading: false,
        type: null,
        avatar_id_upload: null,
        error: null,
      };
    // UPDATE_PROFILE
    case UPDATE_PROFILE:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        type: action.type,
        loading: false,
        userInfo: action.userInfo,
        avatar_id: action.avatar_id,
        avatarImg: action.avatarImg,
        avatar_id_upload: null,
      };
    case UPDATE_PROFILE_FAIL:
      return {
        ...state,
        type: action.type,
        loading: false,
        error: action.error,
        avatar_id_upload: null,
      };
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default profile;
